import React, { useState, useEffect, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import useDebounce from '../../../hooks/useDebounce';
import classNames from 'classnames';

const TextInput = ({
  id,
  handleInputChange,
  metaTag,
  fileIndex,
  tagIndex,
  userInput,
  error,
  setError,
  validateInput,
  hasTriedSubmitting,
}) => {
  const [localFormInput, setLocalFormInput] = useState(userInput);
  const debouncedUserInput = useDebounce(localFormInput, 500);

  //Effect to update debounced userInput
  useEffect(() => {
    handleInputChange(fileIndex, tagIndex, debouncedUserInput);
  }, [debouncedUserInput]);

  //Effect to validate user input on submit
  useEffect(() => {
    if (hasTriedSubmitting > 0) validateInput(localFormInput);
  }, [hasTriedSubmitting]);

  //Effect to monitor changes after a copy action and change in input
  useEffect(() => {
    if (userInput.length != 0) setError('');
    setLocalFormInput(userInput);
  }, [userInput]);

  return (
    <>
      <Form.Control
        value={localFormInput}
        id={metaTag.meta.id}
        key={`${fileIndex}_${tagIndex}_${metaTag.meta.id}`}
        className={classNames(error && 'input-error')}
        maxLength={metaTag.attributes.maxlength}
        onChange={(e) => {
          setLocalFormInput(e.target.value);
        }}
        onBlur={() => {
          validateInput(localFormInput);
        }}
      />
      {error && <div className="error-message">{error}</div>}
    </>
  );
};

export default TextInput;
